import React, { useState } from "react";
import ListItem from "./ListItem";
import { Skeleton } from "antd";
import { getDashboardHighAmount } from "../../../utils/API/getDashboardHighAmount";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { LoadingOutlined } from "@ant-design/icons";

const colors = {
  0: "#4361EE",
  1: "#5CD100",
  2: "#F2B575",
  3: "#8CA0FF",
  4: "#9AE95C"
};

const HighestAmount = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [dataRange, setDataRange] = useState(null);

  useState(() => {
    const fetchData = async () => {
      // wrong error handling
      try {
        setLoading(true);
        let data = await getDashboardHighAmount(dispatch);
        setDataRange(data[0].data_range);

        data = data[0].credits.sort((a, b) => a.rank - b.rank);
        const updatedData = data.map((item, idx) => {
          return { ...item, color: colors[idx] };
        });
        setData(updatedData);
      } catch (error) {
        toast.error(error.message);
        setError("Failed to fetch data");
        // setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (error)
    return (
      <div className="w-full shadow-custom bg-white p-4 gap-4 text-red-500 font-semibold text-xl rounded-2xl mt-4 h-[17.4rem] flex justify-center items-center">
        <LoadingOutlined />
        <p>Data not found !!</p>
      </div>
    );

  return (
    <div className=" w-full shadow-custom bg-white rounded-2xl pb-4">
      <div className="flex justify-between">
        <div className="text-base font-bold ml-2 p-4">
          Top 5 Credits - Highest amount first
        </div>
        <div className=" my-auto mx-3 text-[10px] text-grey-500 font-medium">
          {dataRange}
        </div>
      </div>
      {loading ? (
        <div className="p-4">
          <Skeleton.Button
            block={true}
            active={true}
            style={{ width: "100%", height: "15rem" }}
          />
        </div>
      ) : (
        <ol className="list-none">
          {data.map(({ name, price, color, trend, volume }, index) => (
            <ListItem
              key={`list-data-${index}`}
              index={index}
              trend={trend?.toLowerCase()}
              currentPrice={price}
              color={color}
              volume={volume}
            >
              {name}
            </ListItem>
          ))}
        </ol>
      )}
    </div>
  );
};

export default HighestAmount;
